import React, { memo, useEffect, useState, useMemo } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import  * as TYPES  from '../../models/types';
import Locales from '../../components/Locales';
import { routers } from '../../routers';
import { isMath, backTo, getOuterHeight, isNormalZhEnCss } from '../../utils'
import styles from './styles.module.scss';

import localesToggleW from '../../assets/img/public/icons/localesToggleW.svg';
import localesToggleG from '../../assets/img/public/icons/localesToggleG.svg';
import closeIcon from '../../assets/img/public/close.svg';
import menu from '../../assets/img/public/menu.svg';
import menug from '../../assets/img/public/menug.svg';

import menumw from '../../assets/img/public/menumw.svg';
import menumg from '../../assets/img/public/menumg.svg';


import menuline from '../../assets/img/public/menuline.svg';
import menulineG from '../../assets/img/public/menulineg.svg';
import WeiBo from '../../assets/img/public/icons/WeiBo.svg';
import QQ from '../../assets/img/public/icons/QQ.svg';
import WeChat from '../../assets/img/public/icons/WeChat.svg';

import navBg from '../../assets/img/public/nav/navBg.jpg';



const Index = memo((props) => {
    const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
    const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
    const { value } = useSelector(({scrollNumReducer}) => scrollNumReducer);
    const [flag, setFlag] = useState(false);
    const [mFlag, setMFlag] = useState(false);
    const [isListName, setIsListName] = useState('list');
    const [pathKey, setPathKey] = useState('/');

    const dispatch = useDispatch();
    const { basicDrawerEvent } = actions;

    // 获取 History
    let location = useLocation();
    let navigate = useNavigate();

    // 桌面端
    const isLogo = () => {
      const name = location.pathname;
      const { logos } = window.globalConfig; // 全局配置文件
      const isLogo = value >= 20 ? logos.header.logog : logos.header.logow;
      return name === '/' ? isLogo : logos.header.logog;
    };
    const isMenu = useMemo(() => {
      const name = location.pathname;
      const isMenuGIcon= value >= 20 ? menug : (name === '/' ? menu : menug);
      const isToogleIcon= value >= 20 ? menulineG : (name === '/' ? menuline : menulineG);

      if(value >= 20){
        setIsListName('listg');
      }else{
        setIsListName(name === '/' ? 'list' : 'listg');
      }
      return flag ? isMenuGIcon : isToogleIcon;
    }, [flag, location.pathname, value]);


    // 移动端
    const isMLogo = () => {
      const name = location.pathname;
      const { logos } = window.globalConfig; // 全局配置文件
      const otherLogo = mFlag ? logos.header.logog : logos.header.logog;

      const homeLogo = mFlag ? logos.header.logog : logos.header.logow;
      const isLogo = value >= 20 ? logos.header.logog : homeLogo;
      return name === '/' ? isLogo : otherLogo;
    };

    const isMMenu = useMemo(() => {
      const name = location.pathname;
      const isMenuGIcon= value >= 20 ? menumg : menumw;
      return name === '/' ? (mFlag ? closeIcon : isMenuGIcon) : (mFlag ? closeIcon : menumg);
    }, [location.pathname, mFlag, value]);

    const navbarList = () => {
      const { lang } = localesReducer;
      // array-callback-return
      return routers.map(item => {
        const name = lang === 'English' ? item.nameEN : item.nameZH;
        if(item.path !== '/'){
          return (<li onClick={() => handleJump(item.path)} key={item.path}><span style={{fontWeight: item.path === pathKey ? 500 : 400}}>{name}</span></li>);
        }
      });
    }

    const handleJump = (path) => {
      setFlag(false);
      setMFlag(false);
      navigate(path);
      setPathKey(path);
      backTo();
    }


    const handleClickMenu = () => {
      setFlag(!flag);
    }

    useEffect(() => {
      if(value >= 20) {
        setFlag(true);
      }else{
        setFlag(false);
      }
    }, [value]);

    const desktops = () => {
      const transformCss = flag ? {
        transform: `translate(1000px, 0px)`,
      } : {
        transform: `translate(0px, 0px)`,
      }


      const headBgCss = value >= 20 ? {
          // padding: `40px 65px`,
          padding: `15px 65px`,
          background: '#FFFFFF',
          borderBottom: '1px solid #DDDDDD'
      } : {
        padding: `40px 65px`,
        background: 'transparent',
        borderBottom: '1px solid transparent'
      }
      
      return (
          <header className={styles.normalXl2} style={{...headBgCss, ...props.config}}>
            <div className="flex flex-row justify-between justify-center items-center">
              <div className="left flex-initial">
                <div className={value >= 20 ? "logoScoll" : "logoScoll"} onClick={() => handleJump('/')}><img src={isLogo()} alt=""/></div>
              </div>
              <div className="right flex-initial">
                <div className="content flex flex-row justify-center items-center">
                  <div className="navbar flex flex-row">
                    <ul className={`${isListName} navbarList flex flex-row`} style={transformCss}>
                      { navbarList() }
                    </ul>
                  </div>
                  <div className="menu" onClick={handleClickMenu}><img src={isMenu} alt="" /></div>
                  <Locales
                    config={{
                      icons: [localesToggleW, localesToggleG], // 图标
                      status: flag, // 状态
                      path: location.pathname === '/', // 路径
                      screenTop: value >= 20, // 顶部的值
                    }}
                  />
                </div>
              </div>
            </div>
          </header>
      );
    };


    const handleMClickMenu = () => {
      setMFlag(!mFlag);
    }

    const mobiles = () => {
      const {headerData: {navLinkList}} = localesReducer.layouts;

      const isLogoCss = value >= 20 ? (mFlag ? 'logo' : 'logoNew') : 'logo';

      const navBgs = `url(${navBg}) no-repeat 100% 100% / cover`;
      const isBgColor = value >= 20 ? navBgs : 'transparent';

      const headBgCss = value >= 20 ? {
          padding: `${isMath(recReSizeReducer, mFlag ? 40 : 15)} ${isMath(recReSizeReducer, 65)}`,
          background: mFlag ? isBgColor : '#FFFFFF',
          borderBottom: `${isMath(recReSizeReducer, 1)} solid #DDDDDD`,
          height: mFlag ? getOuterHeight() : 'initial',
          overflow: mFlag ? 'initial' : 'hidden',
      } : {
        padding: `${isMath(recReSizeReducer, 40)} ${isMath(recReSizeReducer, 65)}`,
        background: mFlag ? navBgs : 'transparent',
        borderBottom: `${isMath(recReSizeReducer, 1)} solid transparent`,
        height: mFlag ? getOuterHeight() : 'initial',
        overflow: mFlag ? 'initial' : 'hidden',
      }
      const transformCss = mFlag ? {
        transform: `translate(0rem, 0rem)`,
        paddingTop: isMath(recReSizeReducer, 120),
        height: getOuterHeight() - 100,
        opacity: 1 ,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
      } : {
        transform: `translate(0rem, ${isMath(recReSizeReducer, -1000)})`,
        paddingTop: isMath(recReSizeReducer, 0),
        height: '0rem',
        opacity: 0,
      }

      const navTopCss = mFlag ? {background: '#FFFFFF',} : { background: 'transparent'};

      // const isMStyles = isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
      const isMStyles = isNormalZhEnCss(localesReducer.lang, 'English') ? styles.normalSmEn : styles.normalSm;

      return (
          <header className={isMStyles} style={{...headBgCss}}>
            <div className="navTop" style={navTopCss}>
              {/* <div className="logo" onClick={() => handleJump('/')}><img src={isMLogo()} alt=""/></div> */}
              <div className={isLogoCss} onClick={() => handleJump('/')}><img src={isMLogo()} alt=""/></div>
              <div className="menu" onClick={handleMClickMenu}><img src={isMMenu} alt="" /></div>
            </div>
            <div className="navigation" style={transformCss}>
              <div className="con">
                <Locales
                  config={{
                      icons: [localesToggleW, localesToggleG], // 图标
                      status: mFlag, // 状态
                      path: location.pathname === '/', // 路径
                      screenTop: value >= 20, // 顶部的值
                  }}
                />
                <div className="navbar flex flex-col justify-center items-center">
                  <ul className="list navbarList flex flex-col justify-center items-center">
                    { navbarList() }
                  </ul>
                </div>
              </div>
              <div className="bot flex flex-col justify-center items-center">
                <div className="stayConnected">
                  <ul className="socialMedia">
                    <li><img src={WeiBo} alt="WeiBo" /></li>
                    <li><img src={QQ} alt="QQ" /></li>
                    <li><img src={WeChat} alt="WeChat" /></li>
                  </ul>
                </div>
                <div className="fNavLink">
                  {navLinkList && navLinkList.map((item, index) => {
                    return (
                      <span
                        key={item.id}
                        onClick={() => {
                          switch(index){
                            case 0:
                              handleNavLink(TYPES.CUSTOMIZEDTRAVEL);
                              break;
                            case 1:
                              handleNavLink(TYPES.FAQ);
                              break;
                            default:
                              handleNavLink(TYPES.BOOKINGINSTRUCTIONS);
                          }
                        }}
                      >
                        {item.title}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </header>
      );
    };


    const handleNavLink = (type) => {
      if(type === TYPES.CUSTOMIZEDTRAVEL){
        setFlag(false);
        setMFlag(false);
        navigate('/customTravel');
        backTo();
      }else{
        dispatch(basicDrawerEvent({
          visible: TYPES.DRAWERSHOW,
          options: {
            type,
          },
        }));
      }
      
    }

    const isDesktopMobile = () => {
      return recReSizeReducer > 750 ? desktops() : mobiles();
    };

    return isDesktopMobile();
});
export default Index;
